import {
  ApplicationInstanceCpuTelemetryServiceData,
  ApplicationInstanceMemoryTelemetryServiceData,
} from 'services/Telemetry/ApplicationInstance/applicationInstanceTelemetryServiceType';
import { FetchAction } from 'types/services/redux-action';
import { FetchReducer } from 'types/services/redux-state';

export const FETCH_INSTANCE_MEMORY_AGGREGATE = 'FETCH_INSTANCE_MEMORY_AGGREGATE';

export const FETCH_INSTANCE_MEMORY_AGGREGATE_IS_PENDING = 'FETCH_INSTANCE_MEMORY_AGGREGATE_IS_PENDING';

export const FETCH_INSTANCE_MEMORY_AGGREGATE_IS_ERROR = 'FETCH_INSTANCE_MEMORY_AGGREGATE_IS_ERROR';

export const FETCH_INSTANCE_CPU_AGGREGATE = 'FETCH_INSTANCE_CPU_AGGREGATE';

export const FETCH_INSTANCE_CPU_AGGREGATE_IS_PENDING = 'FETCH_INSTANCE_CPU_AGGREGATE_IS_PENDING';

export const FETCH_INSTANCE_CPU_AGGREGATE_IS_ERROR = 'FETCH_INSTANCE_CPU_AGGREGATE_IS_ERROR';

export const FETCH_INSTANCE_DISTRIBUTION_CURRENT = 'FETCH_INSTANCE_DISTRIBUTION_CURRENT';

export const FETCH_INSTANCE_DISTRIBUTION_CURRENT_IS_PENDING = 'FETCH_INSTANCE_DISTRIBUTION_CURRENT_IS_PENDING';

export const FETCH_INSTANCE_DISTRIBUTION_CURRENT_IS_ERROR = 'FETCH_INSTANCE_DISTRIBUTION_CURRENT_IS_ERROR';

export const FETCH_INSTANCE_DISTRIBUTION_HISTORY = 'FETCH_INSTANCE_DISTRIBUTION_HISTORICAL';

export const FETCH_INSTANCE_DISTRIBUTION_HISTORY_IS_PENDING = 'FETCH_INSTANCE_DISTRIBUTION_HISTORICAL_IS_PENDING';

export const FETCH_INSTANCE_DISTRIBUTION_HISTORY_IS_ERROR = 'FETCH_INSTANCE_DISTRIBUTION_HISTORICAL_IS_ERROR';

export const FETCH_HOST_CAPACITY_CURRENT = 'FETCH_HOST_CAPACITY_CURRENT';

export const FETCH_HOST_CAPACITY_CURRENT_IS_PENDING = 'FETCH_HOST_CAPACITY_CURRENT_IS_PENDING_IS_PENDING';

export const FETCH_HOST_CAPACITY_CURRENT_IS_ERROR = 'FETCH_HOST_CAPACITY_CURRENT_IS_PENDING_IS_ERROR';

export const FETCH_INSTANCE_CRASHES_HISTORY = 'FETCH_INSTANCE_CRASHES_HISTORY';

export const FETCH_INSTANCE_CRASHES_HISTORY_IS_PENDING = 'FETCH_INSTANCE_CRASHES_HISTORY_IS_PENDING';

export const FETCH_INSTANCE_CRASHES_HISTORY_IS_ERROR = 'FETCH_INSTANCE_CRASHES_HISTORY_IS_ERROR';

export const RESET_REDUCER = 'RESET_APPLICATION_INSTANCE_TELEMETRY';

export type TelemetryApplicationInstanceReducerState = FetchReducer<'fetchInstanceCPUAggregate' | 'fetchInstanceMemoryAggregate'>;

export type TelemetryApplicationInstanceActions =
  | FetchAction<'FETCH_INSTANCE_CPU_AGGREGATE', ApplicationInstanceCpuTelemetryServiceData[]>
  | FetchAction<'FETCH_INSTANCE_MEMORY_AGGREGATE', ApplicationInstanceMemoryTelemetryServiceData[]>;
